import React from 'react';
import LoaderWithCompanySelected from "../../components/LoaderWithCompanySelected";
import MyMaterialTable from "../../components/mtable/MyMaterialTable";
import {companyAccountsStore} from "../../store/CompanyAccounts";
import {observer} from "mobx-react";

interface IProps {
}

interface IState {
    loading: boolean,
    error: boolean
}

@observer
export default class AccountList extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: true,
            error: false,

        };
    }

    async componentDidMount() {
        await companyAccountsStore.refresh()
            .then(() => {
                this.setState({loading: false})
            })
            .catch(() => this.setState({
                loading: false,
                error: true
            }));
    }

    render() {
        const {loading, error} = this.state;
        const accounts = companyAccountsStore.bankAccounts;
        return (
            <LoaderWithCompanySelected loading={loading} error={error}>
                <MyMaterialTable
                    title="Accounts & Banks"
                    columns={[
                        {title: 'Name', field: 'name',},
                        {title: 'Account code', field: 'accountCode',},
                        {title: 'IBAN', field: 'iban'},
                    ]}
                    data={accounts}
                    options={{
                        search: true,
                        sorting: false,
                        paging: false,
                        draggable: false,
                    }}
                />
            </LoaderWithCompanySelected>
        );
    }
}